// CommonMark treats a line indented by 4+ spaces as a code block.
// In the community composer that collides with ordinary leading spaces,
// so consume those lines as a paragraph instead. Fenced ``` blocks stay.

export function indentedCodeToParagraph(state, startLine, endLine) {
  if (state.sCount[startLine] - state.blkIndent < 4) {
    return false;
  }

  let nextLine = startLine + 1;
  let last = nextLine;

  while (nextLine < endLine) {
    if (state.isEmpty(nextLine)) {
      nextLine++;
      continue;
    }

    if (state.sCount[nextLine] - state.blkIndent >= 4) {
      nextLine++;
      last = nextLine;
      continue;
    }

    break;
  }

  state.line = last;

  const tokenOpen = state.push("paragraph_open", "p", 1);
  tokenOpen.map = [startLine, state.line];

  const tokenInline = state.push("inline", "", 0);
  tokenInline.content = state
    .getLines(startLine, last, state.blkIndent, false)
    .replace(/\n+$/, "");
  tokenInline.map = [startLine, state.line];
  tokenInline.children = [];

  state.push("paragraph_close", "p", -1);
  return true;
}

export function setup(helper) {
  helper.registerPlugin((md) => {
    md.block.ruler.at("code", indentedCodeToParagraph);
  });
}
